export default __webpack_public_path__ + "img/tokyo_mixer_2022-6f1d39fc313aa78fa2ba5d2c5bd76b14.png";